import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '@styles/common/Error.module.css';

interface AuthorizationErrorProps {
  message: string;
  onLogout: () => void;
}

const AuthorizationError: React.FC<AuthorizationErrorProps> = ({
  message,
  onLogout,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.fullPageContainer} role='alert'>
      <div className={styles.errorIcon}>
        <svg
          width='48'
          height='48'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <circle cx='12' cy='12' r='10'></circle>
          <line x1='12' y1='8' x2='12' y2='12'></line>
          <line x1='12' y1='16' x2='12.01' y2='16'></line>
        </svg>
      </div>
      <h2 className={styles.title}>{t('auth.accessDenied')}</h2>
      <p className={styles.message}>{message}</p>
      <button className={styles.retryButton} onClick={onLogout} type='button'>
        {t('auth.logout')}
      </button>
    </div>
  );
};

export default AuthorizationError;
